import { render, staticRenderFns } from "./news-bar.vue?vue&type=template&id=0f51df6d&scoped=true"
import script from "./news-bar.vue?vue&type=script&lang=js"
export * from "./news-bar.vue?vue&type=script&lang=js"
import style0 from "./news-bar.vue?vue&type=style&index=0&id=0f51df6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51df6d",
  null
  
)

export default component.exports